import { useState } from "react";
const ContactBody = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);
  const [statusType, setStatusType] = useState(null);
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setStatusMessage(null);
    setStatusType(null);
    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          fullName,
          email,
          message: subject ? `Betreff: ${subject}

${message}` : message
        })
      });
      const payload = await response.json();
      if (!response.ok) {
        throw new Error(payload.error || "Senden fehlgeschlagen.");
      }
      setStatusType("success");
      setStatusMessage(payload.message || "Ihre Anfrage wurde gesendet. Wir melden uns bald bei Ihnen.");
      setFullName("");
      setEmail("");
      setSubject("");
      setMessage("");
    } catch (error) {
      setStatusType("error");
      setStatusMessage(error instanceof Error ? error.message : "Senden fehlgeschlagen. Bitte versuchen Sie es sp\xE4ter erneut.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section className="relative overflow-hidden border-t border-amber-100 bg-gradient-to-b from-white via-[#f8f5f1] to-white py-16 sm:py-20 lg:py-28">
            <div className="absolute -left-20 top-0 h-72 w-72 rounded-full bg-amber-200/25 blur-3xl" />
            <div className="absolute -right-20 bottom-0 h-72 w-72 rounded-full bg-emerald-200/20 blur-3xl" />

            <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:gap-16">
                    <div className="lg:w-7/12">
                        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-amber-800">
                            Kontakt
                        </p>

                        <h2 className="font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                            Hiru Ayurveda Resorts (PVT) LTD.
                        </h2>

                        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-gray-700 lg:text-lg">
                            <p>Kudawa Mount Road, Maggona –Kalutara, Sri Lanka</p>

                            <div className="space-y-3 pt-3">
                                <p>
                                    <span className="font-semibold text-[#1f4d3c]">Telefon:</span>
                                    <a href="tel:+94342279248" className="text-[#1f4d3c] transition hover:text-[#d67000]">
                                        +94-34-2279248
                                    </a>
                                </p>
                                <p>
                                    <span className="font-semibold text-[#1f4d3c]">Mobil:</span>
                                    <a href="tel:+94767744180" className="text-[#1f4d3c] transition hover:text-[#d67000]">
                                        +94 (0)76 774 4180
                                    </a>
                                </p>
                                <p>
                                    <span className="font-semibold text-[#1f4d3c]">E-Mail:</span>
                                    <a
    href="mailto:info@hiru-ayurveda-resorts.com"
    className="break-all text-[#1f4d3c] transition hover:text-[#d67000]"
  >
                                        info@hiru-ayurveda-resorts.com
                                    </a>
                                </p>
                            </div>

                            <p className="pt-2 text-base leading-8 text-[#475569] sm:text-lg">
                                Wenn Sie Fragen zu Ihrer Buchung, Ihrem Aufenthalt oder anderen Anliegen haben, zögern Sie bitte nicht, uns zu kontaktieren.
                            </p>
                        </div>
                    </div>

                    <div className="lg:w-5/12">
                        <div className="rounded-[32px] border border-amber-100 bg-white p-6 shadow-[0_30px_80px_rgba(15,23,42,0.12)] sm:p-8 lg:p-10">
                            <form onSubmit={handleSubmit} className="space-y-5">
                                <div>
                                    <label htmlFor="fullName" className="mb-2 block text-sm font-semibold text-[#1f4d3c]">
                                        Ihr Name:
                                    </label>
                                    <input
    id="fullName"
    name="fullName"
    type="text"
    value={fullName}
    onChange={(event) => setFullName(event.target.value)}
    className="w-full rounded-2xl border border-amber-100 bg-[#fdfcf9] px-4 py-3 text-gray-900 outline-none transition placeholder:text-gray-400 focus:border-[#F28600] focus:ring-2 focus:ring-[#F28600]/15"
    placeholder="Geben Sie Ihren Namen ein"
    required
  />
                                </div>

                                <div>
                                    <label htmlFor="email" className="mb-2 block text-sm font-semibold text-[#1f4d3c]">
                                        Ihre E-Mail-Adresse:
                                    </label>
                                    <input
    id="email"
    name="email"
    type="email"
    value={email}
    onChange={(event) => setEmail(event.target.value)}
    className="w-full rounded-2xl border border-amber-100 bg-[#fdfcf9] px-4 py-3 text-gray-900 outline-none transition placeholder:text-gray-400 focus:border-[#F28600] focus:ring-2 focus:ring-[#F28600]/15"
    placeholder="example@email.com"
    required
  />
                                </div>

                                <div>
                                    <label htmlFor="subject" className="mb-2 block text-sm font-semibold text-[#1f4d3c]">
                                        Betreff:
                                    </label>
                                    <input
    id="subject"
    name="subject"
    type="text"
    value={subject}
    onChange={(event) => setSubject(event.target.value)}
    className="w-full rounded-2xl border border-amber-100 bg-[#fdfcf9] px-4 py-3 text-gray-900 outline-none transition placeholder:text-gray-400 focus:border-[#F28600] focus:ring-2 focus:ring-[#F28600]/15"
    placeholder="Betreff Ihrer Anfrage"
    required
  />
                                </div>

                                <div>
                                    <label htmlFor="message" className="mb-2 block text-sm font-semibold text-[#1f4d3c]">
                                        Nachricht:
                                    </label>
                                    <textarea
    id="message"
    name="message"
    value={message}
    onChange={(event) => setMessage(event.target.value)}
    className="min-h-[180px] w-full rounded-2xl border border-amber-100 bg-[#fdfcf9] px-4 py-3 text-gray-900 outline-none transition placeholder:text-gray-400 focus:border-[#F28600] focus:ring-2 focus:ring-[#F28600]/15"
    placeholder="Bitte geben Sie Ihre Nachricht ein"
    required
  />
                                </div>

                                {statusMessage ? <p
    className={`rounded-2xl px-4 py-3 text-sm font-medium ${statusType === "success" ? "border border-emerald-200 bg-emerald-50 text-emerald-800" : "border border-rose-200 bg-rose-50 text-rose-800"}`}
  >
                                        {statusMessage}
                                    </p> : null}

                                <button
    type="submit"
    disabled={isSubmitting}
    className="inline-flex w-full items-center justify-center rounded-full bg-[#F28600] px-8 py-4 text-sm font-semibold text-white shadow-[0_18px_50px_-22px_rgba(242,134,0,0.9)] transition hover:bg-[#d67000] disabled:cursor-not-allowed disabled:opacity-70"
  >
                                    {isSubmitting ? "Wird gesendet..." : "Anfrage senden"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default ContactBody;
